import { JSX, ParentComponent, splitProps } from "solid-js";

export type ButtonProps = {
  kind?:
    | "primary"
    | "secondary"
    | "success"
    | "danger"
    | "warning"
    | "info"
    | "light"
    | "dark";
  disabled?: boolean;
} & JSX.ButtonHTMLAttributes<HTMLButtonElement>;

const Button: ParentComponent<ButtonProps> = (p) => {
  const [local, props] = splitProps(p, ["class", "kind", "children"]);
  return (
    <button
      class={`${local.kind ? `p-2 btn btn-${local.kind}` : "btn"} ${
        local.class ?? ""
      }`}
      {...props}
    >
      {local.children}
    </button>
  );
};

export default Button;
